import agent from "../../agent/agent";

const GET_PAYMENTS = "payments/GET_PAYMENTS";
const CHANGE_LOADING = "payments/CHANGE_LOADING";

const initStage = {
	payments: [],
	isLoading: true
};

const hidePayType = ['alipay'];
const hidePayClass = ['Tron'];

export function getPayments () {
	return async function (dispatch) {
		dispatch({ type: CHANGE_LOADING, value: true });
		let _payments = await agent.get("/api/payments").then((res) => {
			return res.data
		}).catch(() => {
			return []
		});
    _payments = _payments.map((payment) => {
      return {
        ...payment,
        payInfo: (payment.payInfo || []).filter((t) => {
          const isHideType = Boolean(hidePayType.includes(t.paymentMethodType));
          const isHideClass = Boolean(hidePayClass.includes(t.paymentMethodClass));
          return !Boolean(isHideType || isHideClass)
        })
      }
    }).filter((t) => Boolean((t.payInfo || []).length > 0));
		dispatch({
			type: GET_PAYMENTS,
			value: _payments
		})
	}
}

export default function ProfileState (state = initStage, action = {}) {
	switch (action.type) {
		case GET_PAYMENTS: {
			return {
				...state,
				payments: action?.value || [],
				isLoading: false
			}
		}
		case CHANGE_LOADING: {
			return {
				...state,
				isLoading: action?.value
			}
		}
		default:
			return state;
	}
}
